export const APIURI = "https://api.escapely.rlogical.com"; //dev
export const SOCKET_URI = "wss://ws-escapley.immodesta.com"; //dev


// export const APIURI = "http://localhost:3030"; //dev
// export const SOCKET_URI = "wss://ws-escapely-prod.immodesta.com"; //dev
export const REDIRECT_SEQUENCE_NO = 2;
export const REDIRECT_ON_MODE = 'easy'
// export const APIURI = "http://localhost:8080"; //prod

export const customStyleGameIds = [
  "687ab3507d94cb1af7103552",
  // "6810c871d0ea1202b52128a3",
  // "68372f157d94cb1af7b2f1b1",
  // "66588fc326f79c02be440aa3"
  "6810c871d0ea1202b52128a3",
];
